import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
//import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function ScotusCommentsPage() {
    const { id } = useParams();
    const [scotusCase, setScotusCase] = useState(null);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');


    const [openDialog, setOpenDialog] = useState(false);
    const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
    const [comment, setComment] = useState("");
    const [activePostId, setActivePostId] = useState(null);

    const [undoDialogOpen, setUndoDialogOpen] = useState(false);
    const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
    const [pendingUndoScotusCase, setPendingUndoScotusCase] = useState(null);

    const [replyOpen, setReplyOpen] = useState(false);
    const [replyText, setReplyText] = useState("");
    const [activeCommentId, setActiveCommentId] = useState(null);

    const [openVotersDialog, setOpenVotersDialog] = useState(false);
    const [activeVoters, setActiveVoters] = useState([]);
    const [dialogTitle, setDialogTitle] = useState("");

    const [loggedInUser, setLoggedInUser] = useState(null);
    useEffect(() => {
            axios.get("/user/me")
                .then(res => setLoggedInUser(res.data))
                .catch(() => setLoggedInUser(null));
        }, []);

    // fetch scotus case info
    useEffect(() => {
        console.log("ScotusCommentsPage mounted, id =", id);
        axios.get(`/scotusCase/${id}`)
            .then(res => setScotusCase(res.data))
            .catch(err => console.error("Error loading case", err));
        }, [id]);
    //console.log(scotusCase);

    // Fetch comments
    /*useEffect(() => {
    axios.get(`/scotusCase/${id}/comments`)
        .then(res => setComments(res.data))
        .catch(err => console.error("Error loading comments", err));
    }, [id]);*/
    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const fetchComments = async () => {
        if (loading || !hasMore) return;
        try {
            setLoading(true);
            const res = await axios.get(`/scotusCase/${id}/comments`, {
                params: { cursor, limit: 10 }
            });
            setComments(prev => {
                const existingIds = new Set(prev.map(c => c._id));
                const newComments = res.data.comments.filter(c => !existingIds.has(c._id));
                return [...prev, ...newComments];
            });
            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);
        } catch (err) {
            console.error("Error loading comments", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        setComments([]);
        setCursor(null);
        setHasMore(true);
    }, [id]);
    useEffect(() => {
        fetchComments();
    }, [id]);
    const observer = useRef();
    const lastCommentRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
            fetchComments();
            }
        });
        if (node) observer.current.observe(node);
    }, [loading, hasMore]);

    /*const handleSubmitComment = async () => {
        if (!newComment.trim()) return;


        try {
            const res = await axios.post(`/scotusCase/${id}/comment`, { text: newComment }); // NOTE: single 'comment'
            setComments(prev => [res.data, ...prev]);
            setNewComment('');
        } catch (err) {
            console.error("Error submitting comment", err);
        }
    };*/
    const handleSubmitComment = async () => {
      if (!newComment.trim()) return;

      try {
          const res = await axios.post(`/scotusCase/${id}/comment`, {
               text: newComment,
           });

          //const commentRes = await axios.get(`/scotusCase/${id}/comments`);
          //setComments(commentRes.data);
          setComments(prev => [res.data, ...prev]);
          setNewComment('');
      } catch (err) {
          console.error("Error submitting comment", err);
      }
  };

    const toggleVote = async (scotusCaseId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/upvote`);
            const { upvotes, voted } = res.data;


            setScotusCase(prevCase => ({
                ...prevCase,
                upvoteCount: upvotes,
                voted
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };


    const handleSubmit = async () => {
        try {
            await axios.post('/api/govPosts', {
                title,
                content,
                topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
            });
            setOpen(false);
            setTitle('');
            setContent('');
            alert('Post created!');
        } catch (err) {
            console.error('Failed to create post', err);
        }
    };

    const isSameUser = (voteUser, loggedInUserId) => {
        if (!voteUser) return false;
        return typeof voteUser === "string"
            ? voteUser === loggedInUserId
            : voteUser._id === loggedInUserId;
    };
/*
    const toggleForRespondent = async (scotusCaseId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/respondent`);
            const { upvotes, scotusCaseVoted } = res.data;


            setScotusCase(prev => ({
                ...prev,
                respondentCount: upvotes,
                scotusCaseVoted
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };


    const toggleForPetitioner = async (scotusCaseId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/petitioner`);
            const { upvotes, scotusCaseVoted } = res.data;


            setScotusCase(prev => ({
                ...prev,
                petitionerCount: upvotes,
                scotusCaseVoted
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };*/
    /*
    const toggleForPetitioner = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/petitioner`, {commentId});
            const { upvotes, scotusCaseVoted } = res.data;


            //setCases(prev =>
            //    prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, petitionerCount: upvotes, scotusCaseVoted } : scotusCase)
            //);
            setScotusCase(prev =>
                prev.map(scotusCase =>
                    scotusCase._id === scotusCaseId
                    ? {
                        ...scotusCase,

                        // update counts (what you already did)
                        petitionerCount: upvotes,
                        scotusCaseVoted,

                        scotusCaseVoters: [
                            ...(scotusCase.scotusCaseVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        petitionerPowerVotes: [
                            ...(scotusCase.petitionerPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // make sure respondentVotes does NOT contain user
                        respondentPowerVotes: (scotusCase.respondentPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),
                        }
                    : scotusCase
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };*/
    const toggleForPetitioner = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(
                `/scotusCase/${scotusCaseId}/petitioner`,
                { commentId }
            );

            const { upvotes, scotusCaseVoted } = res.data;

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                return {
                    ...prev,

                    petitionerCount: upvotes,
                    //scotusCaseVoted,

                    votedScotusCase: true,
                    votedSide: "petitioner",

                    // update voters 
                    /*scotusCaseVoters: [
                        ...(prev.scotusCaseVoters || []).filter(
                            v => !isSameUser(v, loggedInUser._id)
                        ),
                        {
                            _id: loggedInUser._id,
                            username: loggedInUser.username,
                            first_name: loggedInUser.first_name,
                            last_name: loggedInUser.last_name,
                            profileImageUrl: loggedInUser.profileImageUrl,
                            tier: loggedInUser.tier,
                        },
                    ],

                    // add petitioner vote (deduped)
                    petitionerPowerVotes: [
                        ...(prev.petitionerPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),
                        {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                        },
                    ],

                    // ensure respondent side is clean
                    respondentPowerVotes: (prev.respondentPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),*/
                };
            });
        } catch (err) {
            console.error("Error toggling vote:", err);
        }
    };

/*
  const toggleForRespondent = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/respondent`, {commentId});
            const { upvotes, scotusCaseVoted } = res.data;

            setScotusCase(prev =>
                prev.map(scotusCase =>
                    scotusCase._id === scotusCaseId
                    ? {
                        ...scotusCase,

                        // update counts
                        respondentCount: upvotes,
                        scotusCaseVoted,

                        // update voter list
                        scotusCaseVoters: [
                            ...(scotusCase.scotusCaseVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record respondent vote
                        respondentPowerVotes: [
                            ...(scotusCase.respondentPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // remove from petitionerVotes if present
                        petitionerPowerVotes: (scotusCase.petitionerPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),
                        }
                    : scotusCase
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };
    */
   const toggleForRespondent = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(
                `/scotusCase/${scotusCaseId}/respondent`,
                { commentId }
            );

            const { upvotes, scotusCaseVoted } = res.data;

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                return {
                    ...prev,

                    respondentCount: upvotes,
                    //scotusCaseVoted,

                    votedScotusCase: true,
                    votedSide: "respondent",
                    // update voters 
                    /*scotusCaseVoters: [
                        ...(prev.scotusCaseVoters || []).filter(
                            v => !isSameUser(v, loggedInUser._id)
                        ),
                        {
                            _id: loggedInUser._id,
                            username: loggedInUser.username,
                            first_name: loggedInUser.first_name,
                            last_name: loggedInUser.last_name,
                            profileImageUrl: loggedInUser.profileImageUrl,
                            tier: loggedInUser.tier,
                        },
                    ],

                    // add respondent vote
                    respondentPowerVotes: [
                        ...(prev.respondentPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),
                        {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                        },
                    ],

                    // ensure petitioner side is clean
                    petitionerPowerVotes: (prev.petitionerPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),*/
                };
            });
        } catch (err) {
            console.error("Error toggling vote:", err);
        }
    };



    const handleOpenDialog = (scotusCaseId) => {
       setActivePostId(scotusCaseId);
       setOpenDialog(true);
    };

/*
    const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }


        try {
            const res = await axios.post(`/scotusCase/${activePostId}/comment`, { text: comment }); // NOTE: single 'comment'
            setComments(prev => [res.data, ...prev]);


            if (voteType === "For Respondent") {
                await toggleForRespondent(activePostId);
            } else {
                await toggleForPetitioner(activePostId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };*/


    /*const toggleCommentVote = async (commentId) => {
        try {
                // hit backend endpoint that toggles a vote
                const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);


                // update <posts> in react state so ui rerenders
                // setPosts(prev => ...) receives the previous array of posts and must return a new array
                // prev.map( p => { ... } )
                // iterate through every post p in old array
                // if p is the one user just voted on, return a new object with the fresh upvote info from server
                // otherwise, return p unchanged
            setComments((prev) =>
                prev.map((p) =>
                    p._id === commentId
                        ? {
                            ...p, // copy exisiting post fields
                            upvotes: res.data.upvotes, // updated count
                            voted:   res.data.voted // true or false that user voted
                        }
                        : p // all other posts unchanged
                )
            );


        } catch(err) {
            console.error("Vote error", err);
        }
    };*/
    /*const toggleCommentVote = async (commentId) => {
       try {
           const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);
           const commentRes = await axios.get(`/scotusCase/${id}/comments`);
           setComments(commentRes.data);
       } catch(err) {
           console.error("Vote error", err);
       }
   };*/
   const toggleCommentVote = async (commentId) => {
        try {
            //const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);
            const res = await axios.post(`/scotusCase/${id}/commentReplies/${commentId}/upvote`);

            const { replyUpvotes, replyVoted } = res.data;

            // Update ONLY the affected comment (O(n), no refetch)
            setComments(prev =>
                prev.map(comment =>
                    comment._id === commentId
                    ? {
                        ...comment,
                        upvotes: replyUpvotes,  
                        voted: replyVoted 
                        }
                    : comment
                )
            );

        } catch (err) {
            console.error("Vote error", err);
        }
    };

    const handleReplyOpen = (commentId) => {
        setActiveCommentId(commentId);
        setReplyOpen(true);
    };


    const handleReplyClose = () => {
        setReplyOpen(false);
        setReplyText("");
        setActiveCommentId(null);
    };


    const handleReplySubmit = async () => {
        if (!replyText.trim()) return;

        try {
        const res = await axios.post(`/scotusCase/comments/${activeCommentId}/replies`, {
            text: replyText
        });

        // Update state with new reply
        setComments(prev =>
            prev.map(c =>
            c._id === activeCommentId
                ? { ...c, replies: [...(c.replies || []), res.data] }
                : c
            )
        );

        handleReplyClose();
        } catch (err) {
        console.error("Reply error", err);
        }
    };

    const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }


        try {
            //await axios.post(`/scotusCase/${activePostId}/comment`, { text: comment });
            const commentRes = await axios.post(
                `/scotusCase/${activePostId}/comment`,
                { text: comment }
            );

            const commentId = commentRes.data._id; 

            //setComments(prev => [commentRes.data, ...prev]);
            const getCommentRes = await axios.get(`/scotusCase/${id}/comments`);
            setComments(getCommentRes.data);

            if (voteType === "For Petitioner") {
                await toggleForPetitioner(activePostId, commentId);
            } else {
                await toggleForRespondent(activePostId, commentId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*
    const handleUndoVote = async (scotusCaseId, scotusCase) => {
	    const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);

        const { upvotes, scotusCaseVoted } = res.data;

       if (
            scotusCase.petitionerPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            )
            ) {
                setScotusCase(prev =>
                    prev.map(c =>
                    c._id === scotusCaseId
                        ? {
                            ...c,

                            // keep working count logic
                            petitionerCount: upvotes,
                            scotusCaseVoted,

                            // remove user from arrays so button updates
                            scotusCaseVoters: (c.scotusCaseVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            petitionerPowerVotes: (c.petitionerPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            } else if (
                scotusCase.respondentPowerVotes?.some(
                    vote => isSameUser(vote.user, loggedInUser._id)
                )
            ) {
                setScotusCase(prev =>
                    prev.map(c =>
                    c._id === scotusCaseId
                        ? {
                            ...c,

                            // keep working count logic
                            respondentCount: upvotes,
                            scotusCaseVoted,

                            // remove user from arrays so button updates
                            scotusCaseVoters: (c.scotusCaseVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            respondentPowerVotes: (c.respondentPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            }
    };*/
    /*const handleUndoVote = async (scotusCaseId, scotusCase) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);
            const { upvotes, scotusCaseVoted, deletedCommentId } = res.data;

            const votedPetitioner = scotusCase?.petitionerPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            );

            const votedRespondent = scotusCase?.respondentPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            );

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                return {
                    ...prev,

                    scotusCaseVoted,

                    // update counts
                    ...(votedPetitioner ? { petitionerCount: upvotes } : {}),
                    ...(votedRespondent ? { respondentCount: upvotes } : {}),

                    // remove from global voters
                    scotusCaseVoters: (prev.scotusCaseVoters || []).filter(
                        v => !isSameUser(v, loggedInUser._id)
                    ),

                    // remove from vote arrays
                    petitionerPowerVotes: (prev.petitionerPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),

                    respondentPowerVotes: (prev.respondentPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),
                };
            });

            setComments(prev =>
                prev.filter(comment => comment._id !== deletedCommentId)
            );
        } catch (err) {
            console.error("Error undoing vote:", err);
        }
    };*/
    const handleUndoVote = async (scotusCaseId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);
            const { upvotes, deletedCommentId } = res.data;

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                const updated = { ...prev };

                // Use votedSide as the single source of truth
                if (prev.votedSide === "petitioner") {
                    updated.petitionerCount = upvotes;
                } else if (prev.votedSide === "respondent") {
                    updated.respondentCount = upvotes;
                }

                // Reset vote state (THIS fixes your UI instantly)
                updated.votedScotusCase = false;
                updated.votedSide = null;

                return updated;
            });

            // Remove associated comment (if backend deleted it)
            if (deletedCommentId) {
                setComments(prev =>
                    prev.filter(comment => comment._id !== deletedCommentId)
                );
            }

        } catch (err) {
            console.error("Error undoing vote:", err);
        }
    };


    /*const openPetitionerVoters = (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Petitioner Votes");
        setActiveVoters(scotusCase.petitionerPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openRespondentVoters = (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Respondent Votes");
        setActiveVoters(scotusCase.respondentPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*const openPetitionerVoters = async (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Petitioner Votes");

        try {
            const res = await axios.get(`/scotusCase/${scotusCase._id}/voters?side=petitioner`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openRespondentVoters = async (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Respondent Votes");

        try {
            const res = await axios.get(`/scotusCase/${scotusCase._id}/voters?side=respondent`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    //const scotusRespondentCount = scotusCase.respondentCount || 0;
    console.log(scotusCase);
    const scotusRespondentCount = scotusCase?.respondentCount ?? 0;
    console.log(scotusRespondentCount);
    
    const scotusPetitionerCount = scotusCase?.petitionerCount ?? 0;
    let votePercentage = 0;
 
    if (scotusRespondentCount > scotusPetitionerCount) {
        votePercentage =scotusRespondentCount/(scotusRespondentCount+scotusPetitionerCount)
    } else if (scotusPetitionerCount > scotusRespondentCount) {
        votePercentage = scotusPetitionerCount/(scotusRespondentCount+scotusPetitionerCount)
    }


    let offset = 0;
    if (scotusRespondentCount > scotusPetitionerCount) {
        offset = votePercentage * 50; // move right
    } else if (scotusPetitionerCount > scotusRespondentCount) {
        offset = -votePercentage * 50; // move left
    }


    let tickColor = "blue"; // default at center
    if (offset > 0) {
        tickColor = "red"; // right side
    } else if (offset < 0) {
        tickColor = "red"; // left side
    }

    const navItems = [
        {
            label: "Popular Opinion",
            path: "/Government/popular",
            matchPaths: ["/Government/popular"]
        },
        {
            label: "Following",
            path: "/Government/following",
            matchPaths: ["/Government/following"]
        },
        {
            label: "Supreme Court",
            path: "/Government/SupremeCourt",
            matchPaths: [
            "/Government/SupremeCourt",
            "/scotusCase"
            ]
        },
        {
            label: "Congressional Bills",
            path: "/Government/CongressionalBills",
            matchPaths: ["/page2/b"]
        },
        {
            label: "State Legislature Bills",
            path: "/Government/StateBills",
            matchPaths: ["/Government/StateBills"]
        },
        {
            label: "Elections",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections"]
        }
    ];

    const location = useLocation();

    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };
    //return <h1>Scotus Comments for {id}</h1>;
    return( 
        <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>


           {/* Centered Buttons */}
           {/*<Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                     <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
            </Box>*/}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
            {/* Original Scotus Case Display */}
            <Box
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                }}
            >
                {/*<Button
                    onClick={(e) => {
                        e.stopPropagation(); 
                        joinVideoCall(bill._id)}
                    }
                    variant="outlined"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1
                    }}
                >
                    Join Voice Call
                </Button>*/}

                <Typography
                    fontWeight="bold"
                    sx={{
                        wordBreak: "break-word",
                        pr: "140px",
                        mb: 1
                    }}
                >
                    {scotusCase?.name}
                </Typography>

                {/*<Box
                    display="flex"
                    justifyContent="center"
                    sx={{
                        mb: 2,
                        //my: 1
                    }}
                >
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleOpenDialog(scotusCase._id)}
                        //sx={{ ml: 2.3 }}
                        sx={{ mr: 2.3 }}
                    >
                        Vote
                    </Button>
                </Box>*/}
                {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    scotusCase?.scotusCaseVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    scotusCase?.petitionerPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Petitioner
                    </Button>
                    ) : loggedInUser && scotusCase?.respondentPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Respondent
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            //handleUndoVote(scotusCase._id, scotusCase);
                            setPendingUndoCaseId(scotusCase._id);
                            setPendingUndoScotusCase(scotusCase);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && scotusCase?.votedScotusCase ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ mr: 2.3 }}
                        >
                            {scotusCase.votedSide === "petitioner"
                            ? "Voted For Petitioner"
                            : "Voted For Respondent"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", mr: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(scotusCase._id);
                                setPendingUndoScotusCase(scotusCase);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>

                {/* Vote bar with tick */}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ mb: 2 }}
                    >
                    <Typography variant="body2">For Petitioner</Typography>


                    {/* Bar with tick in middle */}
                    <Box
                        sx={{
                            position: "relative",
                            height: "2px",
                            backgroundColor: "#ccc",
                            width: "300px",
                            mx: 2
                        }}>
                            {/* Tick in the center */}
                            <Box sx={{
                                position: "absolute",
                                top: "-6px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "2px",
                                height: "14px",
                                backgroundColor: "black"
                            }} />
                        
                        {/* Dynamic tick + percentage */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: "-6px",
                                left: `calc(50% + ${offset}%)`,
                                transform: "translateX(-50%)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}
                            >
                            {/* Tick */}
                            <Box sx={{
                                width: "2px",
                                height: "14px",
                                backgroundColor: tickColor
                            }} />


                            {/* Percentage */}
                            <Typography
                                variant="caption"
                                sx={{ mt: "2px", fontSize: "0.7rem" }}
                            >
                                {(votePercentage * 100).toFixed(0)}%
                            </Typography>
                            </Box>
                        </Box>


                        <Typography variant="body2">For Respondent</Typography>
                </Box>

                <Link
                    href={scotusCase?.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View PDF
                    </Link>


                <Box mt={2} display="flex" alignItems="center" gap={1}>
                    <Button
                        size="small"
                        variant={scotusCase?.voted ? "contained" : "outlined"}
                        onClick={() => toggleVote(scotusCase._id)}
                    >
                        ▲ {scotusCase?.voted ? "Unvote" : "Upvote"}
                    </Button>
                    {/*<Typography variant="body2">{scotusCase?.upvoteCount} Visibility Upvotes | {scotusCase?.petitionerCount} For Petitioner Votes | {scotusCase?.respondentCount} For Respondent Votes</Typography>*/}
                    <Typography variant="body2">
                        {scotusCase?.upvoteCount} Visibility Upvotes |{" "}
                        <Box
                            component="span"
                            sx={{ color: "primary.main", }}
                            //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                            //onClick={(e) => openPetitionerVoters(e, scotusCase)}
                        >
                            {scotusCase?.petitionerCount} For Petitioner Votes
                        </Box>{" "}
                        |{" "}
                        <Box
                            component="span"
                            sx={{ color: "primary.main", }}
                            //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                            //onClick={(e) => openRespondentVoters(e, scotusCase)}
                        >
                            {scotusCase?.respondentCount} For Respondent Votes
                        </Box>
                </Typography>
                </Box>

            </Box>
            {/* --- Dialog --- */}
           <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
               <DialogContent>
                   <Box display="flex" gap={2} mb={2}>
                       <Button
                           variant={voteType === "For Petitioner" ? "contained" : "outlined"}
                           onClick={() => setVoteType("For Petitioner")}
                       >
                           For Petitioner
                       </Button>
                       <Button
                           variant={voteType === "For Respondent" ? "contained" : "outlined"}
                           onClick={() => setVoteType("For Respondent")}
                       >
                           For Respondent
                       </Button>
                   </Box>
                   <TextField
                       fullWidth
                       multiline
                       rows={3}
                       placeholder="Explain your power vote (required)"
                       value={comment}
                       onChange={(e) => setComment(e.target.value)}
                   />
               </DialogContent>
               <DialogActions>
                   <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                   <Button
                       variant="outlined"
                       onClick={handleSubmitVote}
                       disabled={!comment || !voteType}
                   >
                       Submit Power Vote
                   </Button>
               </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoScotusCase);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoScotusCase(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

           {/* Comment Form */}
            <Box
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                }}
            >
            <TextField
                fullWidth
                multiline
                rows={2}
                placeholder="Engage in intellectual discourse..."
                value={newComment}
                onChange={e => setNewComment(e.target.value)}
            />
            <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
                Submit Comment
            </Button>
            </Box>


            {comments.length === 0 ? (
                <Typography></Typography>
            ) : (
                comments.map((comment, i) => {
                    const isLast = i === comments.length - 1;
                    return (
                <Box
                    p={2} // padding inside box
                    key={comment._id}
                    ref={isLast ? lastCommentRef : null}
                    onClick={() => history.push(`/scotusCase/${id}/comments/${comment._id}`)}
                    my={2} // vertical margin between posts
                    border="1px solid #ccc" // light grey border
                    borderRadius="8px" // rounded corners
                    sx={{
                        position: "relative",
                        maxWidth: 900, // limit width
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                    }}
            >


                    <Box display="flex" alignItems="flex-start" gap={1}>
                                <Avatar
                                    src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                    alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                    onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
                                />
                                <Box>
                                    <Typography variant="subtitle1" fontWeight="bold"
                                    onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                    >
                                    {comment.author?.first_name && comment.author?.last_name
                                        ? `${comment.author.first_name} ${comment.author.last_name}`
                                        : 'Unknown Name'}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary"
                                    onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                    >
                                    @{comment.author?.username || 'unknown'}
                                    </Typography>


                                    {/* Post content */}
                                    <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                        {comment.text}
                                    </Typography>


                                    {/* Date */}
                                    {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                                        </Typography>*/}
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount
                                        } ${comment.replyCount === 1 ? 'reply' : 'replies'}`}
                                    </Typography>

                                </Box>
                            </Box>


                            {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                                <Button
                                    size="small"
                                    variant={comment.voted ? "contained" : "outlined"}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)}
                                    }
                                >
                                    ▲ {comment.voted ? "Unvote" : "Upvote"}
                                </Button>
                                <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                            </Box>*/}
                            <Box mt={2} display="flex" alignItems="center" gap={1}>
                                {comment.voted ? (
                                    <Box
                                    sx={{
                                        position: "relative",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        "&:hover .voted-btn": {
                                            opacity: 0,
                                        },
                                        "&:hover .undo-btn": {
                                            opacity: 1,
                                            pointerEvents: "auto",
                                        },
                                    }}
                                >
                                        <Button
                                            size="small"
                                            className="voted-btn"
                                            variant="contained"
                                            color="success"
                                            disabled
                                            sx={{
                                            transition: "opacity 0.2s ease",
                                            }}
                                        >
                                        Power Voted
                                    </Button>
                                    <Button
                                            size="small"
                                            className="undo-btn"
                                            variant="contained"
                                            color="error"
                                            sx={{
                                            inset: 0,
                                            position: "absolute",
                                            transition: "opacity 0.2s ease",
                                            opacity: 0,
                                            pointerEvents: "none",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleCommentVote(comment._id)
                                        }}
                                    >
                                            Undo
                                    </Button>
                                </Box>
                                ) : (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)}
                                    }
                                    >
                                        ▲ Power Vote
                                    </Button>
                                )}
                                <Typography variant="body2">{comment.upvotes} Power Votes</Typography>
                        </Box>

                </Box>
                )})
            )}
            <Dialog open={replyOpen} onClose={handleReplyClose}>
            <DialogTitle>Reply to Comment</DialogTitle>
            <DialogContent>
                <TextField
                autoFocus
                fullWidth
                multiline
                minRows={3}
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                placeholder="Write your reply..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleReplyClose}>Cancel</Button>
                <Button onClick={handleReplySubmit} variant="contained">
                Post Reply
                </Button>
            </DialogActions>
            </Dialog>


        </div>

    );
   

}

export default ScotusCommentsPage;
/*
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

function ScotusCommentsPage() {
    const { id } = useParams();
    const [scotusCase, setScotusCase] = useState(null);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');


    const [openDialog, setOpenDialog] = useState(false);
    const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
    const [comment, setComment] = useState("");
    const [activePostId, setActivePostId] = useState(null);


    const [replyOpen, setReplyOpen] = useState(false);
    const [replyText, setReplyText] = useState("");
    const [activeCommentId, setActiveCommentId] = useState(null);


    // Fetch scotus cases info
    useEffect(() => {
        console.log("useEffect firing, id:", id);
        axios.get(`/scotusCase/${id}`)
            .then(res => setScotusCase(res.data))
            .catch(err => console.error("Error loading case", err));
    }, [id]);
console.log(scotusCase);
console.log("ID passed:", id);

 // Fetch comments
 useEffect(() => {
   axios.get(`/scotusCase/${id}/comments`)
     .then(res => setComments(res.data))
     .catch(err => console.error("Error loading comments", err));
 }, [id]);
console.log(comments);

 const handleSubmitComment = async () => {
   if (!newComment.trim()) return;


   try {
     const res = await axios.post(`/scotusCase/${id}/comment`, { text: newComment }); // NOTE: single 'comment'
     setComments(prev => [res.data, ...prev]);
     setNewComment('');
   } catch (err) {
     console.error("Error submitting comment", err);
   }
 };


 const toggleVote = async (scotusCaseId) => {
   try {
       const res = await axios.post(`/scotusCase/${scotusCaseId}/upvote`);
       const { upvotes, voted } = res.data;


       setScotusCase(prevCase => ({
         ...prevCase,
         upvoteCount: upvotes,
         voted
       }));
   } catch (err) {
       console.error('Error toggling vote:', err);
   }
   };


 const handleSubmit = async () => {
   try {
     await axios.post('/api/govPosts', {
       title,
       content,
       topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
     });
     setOpen(false);
     setTitle('');
     setContent('');
     alert('Post created!');
   } catch (err) {
     console.error('Failed to create post', err);
   }
 };


 const toggleForRespondent = async (scotusCaseId) => {
       try {
           const res = await axios.post(`/scotusCase/${scotusCaseId}/respondent`);
           const { upvotes, scotusCaseVoted } = res.data;


           setScotusCase(prev => ({
             ...prev,
             respondentCount: upvotes,
             scotusCaseVoted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const toggleForPetitioner = async (scotusCaseId) => {
       try {
           const res = await axios.post(`/scotusCase/${scotusCaseId}/petitioner`);
           const { upvotes, scotusCaseVoted } = res.data;


          setScotusCase(prev => ({
             ...prev,
             petitionerCount: upvotes,
             scotusCaseVoted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
  };


   const handleOpenDialog = (scotusCaseId) => {
       setActivePostId(scotusCaseId);
       setOpenDialog(true);
   };


   const handleSubmitVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }


       try {
           const res = await axios.post(`/scotusCase/${activePostId}/comment`, { text: comment }); // NOTE: single 'comment'
           setComments(prev => [res.data, ...prev]);


           if (voteType === "For Respondent") {
               await toggleForRespondent(activePostId);
           } else {
               await toggleForPetitioner(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };


   const toggleCommentVote = async (commentId) => {
       try {
            // hit backend endpoint that toggles a vote
            const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);


            // update <posts> in react state so ui rerenders
            // setPosts(prev => ...) receives the previous array of posts and must return a new array
            // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           setComments((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );


       } catch(err) {
           console.error("Vote error", err);
       }
   };




   const handleReplyOpen = (commentId) => {
     setActiveCommentId(commentId);
     setReplyOpen(true);
   };




   const handleReplyClose = () => {
     setReplyOpen(false);
     setReplyText("");
     setActiveCommentId(null);
   };




   const handleReplySubmit = async () => {
     if (!replyText.trim()) return;




     try {
       const res = await axios.post(`/scotusCase/comments/${activeCommentId}/replies`, {
         text: replyText
       });




       // Update state with new reply
       setComments(prev =>
         prev.map(c =>
           c._id === activeCommentId
             ? { ...c, replies: [...(c.replies || []), res.data] }
             : c
         )
       );




       handleReplyClose();
     } catch (err) {
       console.error("Reply error", err);
     }
   };


       const scotusRespondentCount = scotusCase.respondentCount || 0;
       const scotusPetitionerCount = scotusCase.petitionerCount || 0;
       let votePercentage = 0;
 
       if (scotusRespondentCount > scotusPetitionerCount) {
           votePercentage =scotusRespondentCount/(scotusRespondentCount+scotusPetitionerCount)
       } else if (scotusPetitionerCount > scotusRespondentCount) {
           votePercentage = scotusPetitionerCount/(scotusRespondentCount+scotusPetitionerCount)
       }


       let offset = 0;
       if (scotusRespondentCount > scotusPetitionerCount) {
           offset = votePercentage * 50; // move right
       } else if (scotusPetitionerCount > scotusRespondentCount) {
           offset = -votePercentage * 50; // move left
       }


       let tickColor = "blue"; // default at center
       if (offset > 0) {
           tickColor = "#00c853"; // right side
       } else if (offset < 0) {
           tickColor = "red"; // left side
       }


       return (
        <div>
            <h2>Case Comments Page</h2>
            {scotusCase ? <p>{scotusCase.name}</p> : <p>Loading...</p>}
        </div>
       );
}


export default ScotusCommentsPage;
*/